var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"modal-tester-wrapper"},[_c('div',{staticClass:"modal-tester-container"},[_c('p',[_vm._v(" You need to be Beta-tester. Please, "),_c('a',{staticClass:"modal-tester-mail",attrs:{"href":"mailto:info@iloveifc.com"}},[_vm._v(" mail to info@iloveifc.com ")])])])])
}]

export { render, staticRenderFns }